import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const PrivateCustomer: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-30v-342.33l-226.43-163.47c-8.34-5.63-19.06-5.62-27.4 0l-226.17 163.46v107.33h-30v-122.67l239.08-172.78c18.7-12.8 42.86-12.81 61.57-.02l.31.22 239.04 172.57v357.67z' />
    <path d='m120 375h30v90h-30z' />
    <path d='m330.08 660h314.92s0-30 0-30h-284.92c-16.57 0-30 13.43-30 30z' />
    <path d='m195.56 629.75c-38.29 0-69.43-31.15-69.43-69.44s31.15-69.44 69.43-69.44 69.44 31.15 69.44 69.44-31.15 69.44-69.44 69.44zm0-108.87c-21.74 0-39.43 17.69-39.43 39.44s17.69 39.44 39.43 39.44 39.44-17.69 39.44-39.44-17.69-39.44-39.44-39.44z' />
    <path d='m300 690h-30c0-33.08-33.92-60-75.62-60s-75.62 26.92-75.62 60h-30c0-24.58 11.36-47.52 31.98-64.59 19.8-16.39 45.95-25.41 73.64-25.41s53.84 9.02 73.64 25.41c20.62 17.07 31.98 40 31.98 64.59z' />
  </IconBase>
));

PrivateCustomer.displayName = 'PrivateCustomer';

export default PrivateCustomer;
